import { useEffect, useState } from 'react'
import { api } from './api'

// Provider catalog for BYO keys — server-driven from GET /api/v1/user/apikey
// (registry in backend/config/llm_models.py). Shared by Settings and
// onboarding (parity invariant); rendered by components/ProviderSelect.

export interface ProviderInfo {
  id: string
  label: string
  enabled: boolean
}

interface ApiKeyInfo {
  provider: string | null
  providers: ProviderInfo[]
}

const FALLBACK_PROVIDERS: ProviderInfo[] = [{ id: 'anthropic', label: 'Anthropic', enabled: true }]

export function useProviderCatalog(): {
  providers: ProviderInfo[]
  currentProvider: string | null
  loaded: boolean
} {
  const [providers, setProviders] = useState<ProviderInfo[]>(FALLBACK_PROVIDERS)
  const [currentProvider, setCurrentProvider] = useState<string | null>(null)
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    let cancelled = false
    void (async () => {
      try {
        const info = await api.get<ApiKeyInfo>('/api/v1/user/apikey')
        if (cancelled) return
        if (info.providers.length > 0) setProviders(info.providers)
        setCurrentProvider(info.provider)
      } catch {
        // Catalog fetch failing must never block key entry — fall back to Anthropic.
      } finally {
        if (!cancelled) setLoaded(true)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [])

  return { providers, currentProvider, loaded }
}

export function providerLabel(providers: ProviderInfo[], id: string): string {
  return providers.find((p) => p.id === id)?.label ?? 'Anthropic'
}

// Dropdown option text: disabled providers are visible but marked coming soon.
export function providerOptionLabel(p: ProviderInfo): string {
  return p.enabled ? p.label : `${p.label} (coming soon)`
}
